import axiosInstance from "../api/axiosInstance";

const DEFAULT_MODEL = process.env.REACT_APP_GEMINI_MODEL || "gemini-2.5-flash";
const MAX_CONTEXT_MESSAGES = 6;

const formatApiError = (error) => {
    const data = error?.response?.data;
    if (data?.message) {
        return data.message;
    }

    if (error?.response?.status === 401) {
        return "Not authenticated. Please log in again and retry.";
    }

    if (error?.response?.status === 422) {
        return "Invalid request. Prompt is required.";
    }

    return error?.message || "Failed to generate template with AI.";
};

/**
 * Generate / refine email HTML via backend Gemini wrapper.
 * POST /api/ai/email-template/generate
 */
export const generateEmailTemplateWithGemini = async ({
    prompt,
    currentHtml = "",
    context = [],
    model = DEFAULT_MODEL,
}) => {
    const trimmedPrompt = String(prompt || "").trim();
    if (!trimmedPrompt) {
        throw new Error("Prompt is required.");
    }

    const recentContext = (Array.isArray(context) ? context : [])
        .filter((item) => item?.role === "user" || item?.role === "assistant" || item?.role === "model")
        .slice(-MAX_CONTEXT_MESSAGES)
        .map((item) => ({
            role: item.role === "assistant" ? "assistant" : item.role,
            text: String(item.text || ""),
        }))
        .filter((item) => item.text);

    try {
        const response = await axiosInstance.post("/ai/email-template/generate", {
            prompt: trimmedPrompt,
            currentHtml: currentHtml || "",
            context: recentContext,
            model,
        });

        const data = response?.data;

        if (!data?.success) {
            throw new Error(data?.message || "AI template generation failed.");
        }

        const html = String(data.html || data.rawText || "").trim();
        if (!html) {
            throw new Error("AI returned an empty template.");
        }

        const usedModel = data.model || model;

        return {
            html,
            summary: `Email template updated using ${usedModel}.`,
            model: usedModel,
            finishReason: data.finishReason ?? null,
            usage: data.usage ?? null,
            rawText: data.rawText ?? html,
        };
    } catch (error) {
        throw new Error(formatApiError(error));
    }
};
